import Vue from 'vue'
import axios from "axios"
import { SingletonAreas } from './components/flowchart/nodes/_service/singletonAreas';
import Mediator from './components/dashboard/manageIndicator/utilities/Mediator';
import { parseBR } from './components/flowchart/utils/numbers.js';

export var urlMainAPI = "";
var config = {};
var eventBuss = new Vue()

export function showError(e) {  
    if (e && e.response && e.response.data) {
        Vue.toasted.global.defaultError({
            msg: e.response.data
        })
    } else if (typeof e === 'string') {
        Vue.toasted.global.defaultError({
            msg: e
        })
    } else {
        Vue.toasted.global.defaultError()
    }
}

export function defaultSuccess(e) {
    if (e && e.response && e.response.data) {
        Vue.toasted.global.defaultSuccess({
            msg: e.response.data
        })
    } else if (typeof e === 'string') {
        Vue.toasted.global.defaultSuccess({
            msg: e
        })
    } else {
        Vue.toasted.global.defaultSuccess()
    }
}

export function emitEventBuss(caption, data) {
    eventBuss.$emit(caption, data)
}

export function onEventBuss(caption, callback) {
    eventBuss.$on(caption, function (data) { callback(data) })
}

export async function getUrlBase(){
    let url = urlAdjustment();
    await axios
    .get(`${url}frontCnSettings.json`)
    .then(res => {
        config = res.data
        urlMainAPI = `${config.protocol || "http"}://${config.host || "localhost"}:${config.port || "65122"}/${config.backendAlias ? config.backendAlias + "/" : ""}api/main`
        console.log("urlMainAPI: ", urlMainAPI)
    })
}

export async function updateMyUserPermission(axios, vueStorage){
    let user = JSON.parse(localStorage.userKey)
    let system = user.role == "PGDI" ? "P" : "G"
    await axios.get(`${urlMainAPI}/updatemypermissions/${user.Id}/${system}/${user.UnitId}`).then(res => {
        if(res.status == 200){
            let Permissions = JSON.parse(res.data)
            user.Permissions = Permissions
            if(vueStorage){
                vueStorage.commit("setUser", user)
                vueStorage.get
            }
            localStorage.userKey = JSON.stringify(user);
        }
    }).catch(console.error)
}

export const urlAdjustment = () =>{
    let urlFull = window.location.href
    let host = urlFull.split("//")[0]
    let urlBaseFull = urlFull.split("//")[1].split("/")[0]
    let url = urlBaseFull.split(":")[0]
    let port = urlBaseFull.split(":")[1]
    let alias = process.env.VUE_APP_DIRECTORY
    if (port)
        return `${host}//${url}:${port}/${alias ? alias + "/" : ""}`
    return `${host}//${url}/${alias ? alias + "/" : ""}`
}

export async function validateToken() {
    const tk = localStorage.getItem("tk");
    
    if(!tk) { 
        delete axios.defaults.headers.common["Authorization"];
        return false 
    }

    axios.defaults.headers.common["Authorization"] = `bearer ${tk}`;
    return true
}

export function parseToNumberInSentence(num) {
    if((num+"").match(/\d,\d/g) && (num+"").match(/\d\.\d/g)){
        num = (num+"").replace(/(\d)\.(\d)/g, "$1$2").replace(/(\d),(\d)/g, "$1.$2")
    } else if((num+"").match(/\d,\d/g)) {
        num = (num+"").replace(/(\d),(\d)/g, "$1.$2")
    }
    return num
}

export function SimpleNumberFormat(num) {
    if (num == "true" || num == "false") return num;
    if (num == null || num == undefined || num == '' || String(num).match(/[a-zA-Z]/)) return 0;
    
    num = parseToNumberInSentence(num)

    return parseFloat(num);
}

export function NumberFormatToNode(num) {
    if (num == "true" || num == "false") return num;
    if(num == null || num == undefined || num == '' || String(num).match(/[a-zA-Z]/)) return "0,00";
    
    num = parseToNumberInSentence(num);
    
    if(isNaN(num)){
        try { 
        return JSON.parse(num.toLocaleLowerCase()); }
        catch { 
            return num
        }
    }
    num = parseFloat(num)
    if (num > 1 || num < -1)
        num = num.toLocaleString('pt-br', {minimumFractionDigits: 1, maximumFractionDigits: 2});
    else 
        num = num.toLocaleString('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 4});
    return num
}

export function ParseNumberToUser(num) {
    try{
      if(num == null || num == undefined || num == '') return "0,00";
      
      if(num == -9999 || num == -9999) return "-"
      
      num = NumberFormatToNode(num)

      let rgxBrazilianPattern = new RegExp(/^[+-]?(?:\d{1,3}(?:(?:.\d{3})+)|\d+)(?:,\d+)?$/g)
      let rgxError = new RegExp(/\.\d\d\d\.\d\d?\b/)
      
      if (rgxBrazilianPattern.test(num + "")) {
          num = (num + "").replace(/\./g, "").replace(/,/g, ".")
      } 
      else if(rgxError.test(num + "")) {
          let splitNum = num.split(".");
          num = "";
          splitNum.forEach((n, i) => {
              if(i == splitNum.length -1)
                  num+= "." + n
              else
                  num+= n

          })

      } else {
          num = (num + "").replace(/,/g, "")
      }
    
      if(isNaN(num)){
        try { 
          if(num.match(/[a-zA-Z]/gi)) return "0,00"
          return JSON.parse(num.toLocaleLowerCase()); }
        catch { 
          //console.log('NumberFormat: Falha na converção de valor :>> ', num);
          if(num.toString() == 'NaN')
            return "0,00"
          return num
        }
      }
      num = parseFloat(num)
  
      let removeDigit = false;
      if(num < -1 || num > 1)
      {
        num = num.toLocaleString('pt-br', {minimumFractionDigits: 1, maximumFractionDigits: 3});
        
        if(num.split(',')[1].length == 3)
          removeDigit = true
      }
      else
      {
        num = num.toLocaleString('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 6});
        
        if(num.split(',')[1].length == 5)
          removeDigit = true
      }
  
      return removeDigit ? num.slice(0, num.length - 1) : num 
  }
  catch(e)
  {
      console.log('NumberFormat Error :>> ' + num, e);
      return "0,00"
  }
}

export var ParseNumber = parseBR;

export var clearAllData = function(){
    localStorage.clear()
    sessionStorage.clear()
    SingletonAreas.KillAllSingletons();
    Mediator.notify(null, "kill");
}

export function getDate(date = new Date()){
    return {
        year: date.getFullYear(),
        month: date.getMonth().toString().length == 1? `0${date.getMonth()}` : date.getMonth(),
        day: date.getDay().toString().length == 1? `0${date.getDay()}` : date.getDay(),
        hour: date.getHours().toString().length == 1? `0${date.getHours()}` : date.getHours(),
        minutes: date.getMinutes().toString().length == 1? `0${date.getMinutes()}` : date.getMinutes(),
        seconds: date.getSeconds().toString().length == 1? `0${date.getSeconds()}` : date.getSeconds()
    }
}

export function dateTimeDefault(date = new Date()) {
    let objDate = getDate(date) 
    return `${objDate.year}-${objDate.month}-${objDate.day} ${objDate.hour}:${objDate.minutes}:${objDate.seconds}`
}

export function getLDCSystem(){
    return localStorage.getItem("isLDCSystem")
}

export default {
    urlMainAPI,
    showError,
    defaultSuccess,
    getUrlBase,
    validateToken,
    urlAdjustment,
    NumberFormatToNode,
    ParseNumberToUser,
    ParseNumber,
    clearAllData,
    dateTimeDefault,
    SimpleNumberFormat,
    updateMyUserPermission,
    getLDCSystem
    //userKey
}
